import { createFileRoute, redirect } from "@tanstack/react-router";
import { DOCS_API_REFERENCE_PATH } from "@/lib/docs-paths";
import { isPublicApiSurfaceEnabled } from "@/lib/modules";

export const Route = createFileRoute("/_marketing/developers/api/")({
	beforeLoad: () => {
		if (!isPublicApiSurfaceEnabled()) {
			throw redirect({ to: "/" });
		}
		throw redirect({ to: DOCS_API_REFERENCE_PATH, replace: true });
	},
});
